import * as React from 'react';
import { useRouter } from 'next/router';
import { ListItem, ListItemButton, Box, Collapse } from '@mui/material';

import { useDevice } from '@hooks';

import { MenuItemLink } from '../MenuItemLink';
import styles from './menuMyHubItem.styles';

const MenuMyHubItem = ({ routes, isExpanded, route, onCloseMenu }) => {
  const { pathname } = useRouter();

  const { isMobile, isTablet } = useDevice();

  const handleClick = () => {
    if (isMobile || isTablet) onCloseMenu();
  };

  const isSelected =
    !!route.url &&
    route.url !== '/' &&
    (pathname === route.url || pathname.startsWith(`${route.url}/`));

  const idx = routes.findIndex((opt) => opt === route);

  const isFirst = idx === 0;

  const isLast = idx === routes.length - 1;

  return (
    <Collapse
      in={isExpanded}
      timeout="auto"
      unmountOnExit
      aria-expanded={isExpanded}
    >
      <Box
        sx={styles.submenuMyHub}
        role="menu"
        aria-label={`${route.key}-myhub-submenu`}
      >
        <ListItem key={route.key} disablePadding>
          <ListItemButton
            component={route.url ? MenuItemLink : Box}
            href={route.url || undefined}
            onClick={handleClick}
            selected={isSelected}
            sx={{
              ...styles.subMenuMyHubItem(isFirst, isLast),
              pointerEvents: 'auto',
            }}
            role="menuitem"
            aria-disabled={!route.url}
          >
            <Box sx={styles.subMenuMyHubItemInnerWrapper}>
              <Box>
                <Box sx={styles.dummyMarginElement} />
                <Box sx={styles.title}>{route.title}</Box>
              </Box>
            </Box>
          </ListItemButton>
        </ListItem>
      </Box>
    </Collapse>
  );
};

export default MenuMyHubItem;
